import React, { useState, useEffect } from 'react'

import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import { startLoading, doneLoading } from '../../../utils/loading'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
import ContentHeader from '../../../components/ContentHeader/ContentHeader'
import { Panel, Row, Col, ControlLabel, RadioGroup, Radio, Message } from 'rsuite'
import classNames from 'classnames'
import { isRequired } from '../../../utils/ValidatorUtils'
import { useForm, Controller } from 'react-hook-form'
import SaveButton from '../../../components/buttons/saveButton/SaveButton'
import {
  getApprovalPdpa,
  updateApprovalPdpa,
} from '../../../redux/actions/PersonalDataProtectionAct'
import OverlayLoader from '../../../components/OverlayLoader/OverlayLoader'

export default function PersonalDataProtectionAct() {
  const { register, handleSubmit, errors, control, setValue, clearErrors, getValues } = useForm()

  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()

  const projectId = sessionStorage.getItem('projectId')
  const [errorMsg, setErrorMsg] = useState()

  useEffect(() => {
    // console.log('load AttachFilesView projectId', projectId)
    handleGetSchema()
  }, [])

  const handleGetSchema = async () => {
    setIsLoading(true)
    startLoading()
    try {
      const _schema = await getApprovalPdpa(projectId)

      setSchema(_schema)
    } catch (e) {
      // console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  const onsubmitApprovalPdpa = async (data) => {
    // console.log('onsubmit ', projectId, data)

    setIsLoading(true)
    startLoading()
    try {
      let request = {
        value: data.roleOfGrantreePDPA,
      }

      const response = await updateApprovalPdpa(projectId, request)
      // console.log('response update ', response)
      // setSchema(_schema)
      if (response.success) {
        setErrorMsg({ type: 'success', description: 'บันทึกสำเร็จ' })
        // console.log('is success')
        // handleGetSchema()
      } else {
        setErrorMsg({ type: 'error', description: response.errorMessage })
      }

      setTimeout(() => setErrorMsg(null), 5000)
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  if (error) {
    return (
      <SidebarProposal>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  // if (!schema || isLoading) {
  //   return (
  //     <SidebarProposal>
  //       <PanalLoadingTemplate />
  //     </SidebarProposal>
  //   )
  // }

  return (
    <>
      <SidebarProposal statusDefault={1}>
        <ContentHeader header={schema?.header} subHeader={schema?.subHeader} />

        {isLoading && <OverlayLoader />}

        {schema && (
          <Panel
            shaded
            header={schema.header}
            bordered
            collapsible
            defaultExpanded
            style={{ marginBottom: '1em' }}
          >
            <Row>
              <Col xs={24} sm={24} md={24} lg={24} style={{ marginTop: '10px' }}>
                <ControlLabel
                  className={classNames(
                    isRequired(schema?.forms?.roleOfGrantreePDPA?.validators) && 'required'
                  )}
                >
                  <b>{schema.forms?.roleOfGrantreePDPA.label}</b>
                </ControlLabel>
                <Controller
                  name={schema.forms?.roleOfGrantreePDPA.name}
                  control={control}
                  defaultValue={schema?.forms?.roleOfGrantreePDPA.value}
                  render={(props) => {
                    // console.log('pppp ', props.value)
                    return (
                      <RadioGroup
                        value={props.value}
                        onChange={(value) => {
                          props.onChange(value)
                          // handlerChangeRoleOfGrantree(value)
                        }}
                      >
                        {schema.forms?.roleOfGrantreePDPA.options?.map((item, index) => {
                          return (
                            <Radio
                              value={item.value}
                              disabled={schema.forms?.roleOfGrantreePDPA.disabled}
                              index={index}
                            >
                              {item.label}
                            </Radio>
                          )
                        })}
                      </RadioGroup>
                    )
                  }}
                />
              </Col>
            </Row>

            <Row style={{ marginTop: '30px' }}>
              <Col xs={24} sm={24} md={24} lg={24}>
                <h5>คำอธิบายเพิ่มเติมเกี่ยวกับ PDPA</h5>
                <p style={{ marginTop: 10 }}>
                  (1) ภาคีที่เป็นผู้ควบคุมข้อมูลส่วนบุคคล (Data Controller) หมายถึง
                  บุคคลหรือนิติบุคคลซึ่งมีอำนาจหน้าที่ตัดสินใจเกี่ยวกับการเก็บรวบรวม ใช้
                  หรือเปิดเผยข้อมูลส่วนบุคคล (ไม่ต้องเซ็นข้อตกลงการประมวลผลข้อมูลส่วนบุคคล (DPA) กับ
                  สสส.)
                </p>

                <p style={{ marginTop: 10 }}>
                  (2) ภาคีที่เป็นผู้ประมวลผลข้อมูลส่วนบุคคล (Data Processor) หมายถึง
                  บุคคลหรือนิติบุคคลซึ่งดำเนินการเกี่ยวกับการเก็บรวบรวม ใช้
                  หรือเปิดเผยข้อมูลส่วนบุคคล <b>ตามคำสั่งหรือในนามของ สสส.</b>
                </p>

                <p style={{ marginTop: 10 }}>
                  โดยภาคีผู้รับทุนที่เป็นผู้ประมวลผลข้อมูลส่วนบุคคล (Data Processor)
                  จะต้องลงนามข้อตกลงการประมวลผลผลข้อมูลส่วนบุคคล (Data Processing Agreement: DPA)
                  กับ สสส. (ตามมาตรา 40 พ.ร.บ.คุ้มครองข้อมูลส่วนบุคคล พ.ศ. 2562)
                </p>

                <br />

                <p style={{ marginTop: 8 }}>
                  ตารางตัวอย่าง โครงการที่ภาคีผู้รับทุนทำหน้าที่เป็นผู้ควบคุมข้อมูลส่วนบุคคล (Data
                  Controller) หรือทำหน้าที่เป็นผู้ประมวลผลข้อมูลส่วนบุคคล (Data Processor)
                </p>

                <table style={{ width: '100%', marginTop: 8 }} border={1}>
                  <tr>
                    <th style={{ padding: 8, width: '50%' }}>
                      โครงการ ที่ภาคีทำหน้าที่เป็นผู้ควบคุมข้อมูลส่วนบุคคล (Data Controller)
                    </th>
                    <th style={{ padding: 8, width: '50%' }}>
                      โครงการ ที่ภาคีทำหน้าที่เป็นผู้ประมวลผลข้อมูลส่วนบุคคล (Data Processor)
                    </th>
                  </tr>
                  <tr>
                    <td style={{ padding: 8, verticalAlign: 'unset' }}>
                      <ol>
                        <li>จัดซื้อจัดจ้างทำของที่ระลึก (เสื้อ, ถุงผ้า, ปฏิทิน)</li>
                        <li>ใช้บริการพัสดุไปรษณีย์</li>
                        <li>จ้างซ่อมบำรุงนิทรรศการสืบสร้างสุข</li>
                        <li>จัดทำชุดข้อมูลและพัฒนาสื่อเผยแพร่องค์ความรู้สุขภาวะ</li>
                        <li>จัดจ้างผลิตภาพยนตร์โฆษณาฯ</li>
                        <li>โครงการทุนอุปถัมภ์</li>
                        <li>จ้างทีมตรวจภายนอก (IA) หรืองานที่เป็นวิชาชีพอิสระ</li>
                        <li>
                          สำนัก/ฝ่าย จ้างภาคีดำเนินโครงการ
                          (โดยภาคีเป็นผู้วางแผนการดำเนินการและวิธีการเก็บรวบรว ม ใช้ และเปิดเผย เอง)
                          เช่น การรับทุนประเภทแผนงาน (program) หรือประเภทชุดโครงการ (project
                          package) หรือโครงการประเภทร่วมทุน
                        </li>
                      </ol>
                    </td>
                    <td style={{ padding: 8, verticalAlign: 'unset' }}>
                      <ol>
                        <li>
                          จ้างภาคีไปจัดเก็บข้อมูล (Survey, Poll) ที่มีข้อมูลส่วนบุคคล (แบบสอบถาม,
                          ผ่านระบบ)
                        </li>
                        <li>
                          นำข้อมูลส่วนบุคคลที่สำนัก/ฝ่ายดูแลอยู่ไปจ้างภาคีภายนอก วิเคราะห์ (Data
                          Analytics)
                        </li>
                        <li>การนำข้อมูลไปฝากไว้บนคลาวด์ของบริษัทภายนอก</li>
                        <li>จ้างบริษัทรับดูแลเว็บไซต์ระบบสมาชิกของ สสส. (สำนัก/ฝ่าย)</li>
                        <li>จ้างบริษัทพัฒนาระบบ (มีข้อมูลส่วนบุคคล)</li>
                        <li>จ้างบริษัทจัดทำเงินเดือน สำหรับเจ้าหน้าที่ ลูกจ้าง</li>
                        <li>
                          ใช้บริการระบบบัญชีจากผู้ให้บริการภายนอก
                          (ฐานข้อมูลอยู่ที่ผู้ให้บริการภายนอก)
                        </li>
                        <li>
                          สำนัก/ฝ่าย จ้างภาคีดำเนินโครงการ (โดยสำนัก/ฝ่ายเป็นผู้วาง แผนการดำเนินการ
                          และวิธีการเก็บรวบรวม ใช้ และเปิดเผย เอง)
                        </li>
                      </ol>
                    </td>
                  </tr>
                  <tr>
                    <td style={{ padding: 8 }}>
                      ไม่ต้องลงนามข้อตกลงการประมวลผลข้อมูลส่วนบุคคล (DPA) กับ สสส.
                    </td>
                    <td style={{ padding: 8 }}>
                      จะต้องลงนามข้อตกลงการประมวลผลข้อมูลส่วนบุคคล (DPA) กับ สสส.
                    </td>
                  </tr>
                </table>

                <div style={{ marginTop: 10 }}>
                  <u>หมายเหตุ</u> สำนัก/ฝ่าย
                  จะเป็นผู้ตัดสินเองว่าภาคีรับทุนโครงการจะเป็นผู้ควบคุมข้อมูลส่วนบุคคล (Data
                  Controller) หรือจะเป็นผู้ประมวลผลข้อมูลส่วนบุคคล (Data Processor) ของโครงการนั้นๆ
                </div>
              </Col>
            </Row>

            <hr />

            {errorMsg && (
              <Message
                showIcon
                type={errorMsg.type}
                description={errorMsg.description}
                style={{ marginBottom: 20 }}
              />
            )}

            <SaveButton onClick={handleSubmit(onsubmitApprovalPdpa)}>
              {schema?.forms?.buttonText}
            </SaveButton>
          </Panel>
        )}
      </SidebarProposal>
    </>
  )
}
